import type { FC } from 'react';
import type { ButtonProps } from 'react-native-paper';

import {
  lableButtonStyleButton,
  lableButtonStyleLabel
} from '@/features/posts/styles';
import { OutlinedButton } from '@/shared/components/OutlinedButton';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const LabelButton: FC<ButtonProps> = ({ children, ...props }) => {
  const theme = useAppTheme();

  // Todo: why was button instead of chip used?
  return (
    <OutlinedButton
      style={lableButtonStyleButton}
      {...props}
      labelStyle={[
        lableButtonStyleLabel,
        props.icon ? { marginRight: 16 } : {}
      ]}
      outlineColor={theme.colors.outlineVariant}
    >
      {children}
    </OutlinedButton>
  );
};
